import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { App, Button, DatePicker, Flex, Form, Input, InputNumber, Modal, notification, Result, Select, Spin, Steps, Tabs } from "antd";
import { ProductSelect } from "@/components/Selector";
import { RequirementAddWrap } from "./style";
import EditRequirement from "../../components/EditRequirement";
import { RequirementColumn } from "../../type";
import { RequirementAdd, RequirementAddItemUseRepl, RequirementConfirmTypeEnum } from "@/types/requirement";
import RequirementForm, { RequirementFieldType } from "../../components/RequirementForm";
import RequirementSteps from "../../components/RequirementSteps";
import useAddRequirement from "../../hooks/useAddRequirement";
import { getRequirementConfirmItem, numFormmater } from "../../util";
import useRequirementParams from "../../hooks/useRequirementParams";
import { PageId } from "@/types/page";
import dayjs from "dayjs";
import { Product } from "@/types/product";
import requirementApis from "@/apis/requirement";
import MatchBom from "../Create/components/MatchBom";
import { divided, multi, plus, roundToDecimal } from "@/utils/calc";
import { fetch } from "@/apis/bom";
import { BomItem } from "@/types/bom";
import MatchStock from "../Create/components/MatchStock";
import { MatchedRequirementColumn } from "../Create";
import { DataWrap, ModalWrap } from "../Create/style";
import SText from "@/styles/SText";
import PreOutData from "../Create/components/PreOutData";
import { ChangeEnum, OperateEnum } from "@/types/inventory";
import { SourceTypeEnum } from "@/types/common";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { orderAdd, orderPreOut } from "@/apis/inventoryv2";
import { OrderAddV2, OrderV2 } from "@/types/inventoryV2";
import { buildCreateRequirementPreOutLocationTypes, DEFAULT_CREATE_REQUIREMENT_PRE_OUT_LOCATION_TYPES, hasCreateRequirementPreOutLocationTypes } from "../Create/utils/preOutLocationTypes";
import SelectLocationType from "@/components/Selector/SelectLocationType";
import { AddFactoryInventory, FactoryInventorySourceType } from "@/types/factoryInventory";
import { fInventoryAdjust } from "@/apis/factoryInventory";
import ReTryPreOut from "../../components/ReTryPreOut";


interface IRequirementKeys {
  productId: string;
  requireCount: number;
  desc: string;
  mrd: number;
  eps: number;
}

const RequirementHandleAdd: FC<{ open: boolean, setOpen: (flag: boolean) => void }> = ({
  open,
  setOpen
}) => {
  const { t } = useTranslation();
  const { pageId } = useRequirementParams(true);

  const { modal } = App.useApp();
  const [add, addLoading] = useAddRequirement();
  const [form] = Form.useForm<IRequirementKeys>();

  const conetentRef = useRef<HTMLDivElement>(null);

  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [current, setCurrent] = useState<number>(0);
  const [subs, setSubs] = useState<Array<RequirementColumn>>([])
  const [formData, setFormData] = useState<RequirementFieldType>();
  const [number, setNumber] = useState<string>(""); // 需求清单完成的提示 - 需求清单编号number显示
  const [proTemp, setProTemp] = useState<Product | null>(null); // 需求清单完成的提示 - 需求清单编号number显示

  const [bomLoading, setBomLoading] = useState<boolean>(false); // 匹配bom
  const [matchStock, setMatchStock] = useState<boolean>(false);
  const [matchFactory, setMatchFactory] = useState<boolean>(false);
  const [isMerge, setIsMerge] = useState<boolean>(false);

  const [disNext, setDisNext] = useState<boolean>(false);
  const [matchedProducts, setMatchedProducts] = useState<Array<MatchedRequirementColumn>>([]);     //匹配库存
  const curOrg = useSelector((state: RootState) => state.orgReducer.curOrg);
  const [locTypes, setLocTypes] = useState<number[]>([1]);
  const [failItems, setFailItems] = useState<MatchedRequirementColumn[]>([]);
  const [failAdd, setFailAdd] = useState<OrderAddV2 | null>(null);

  const [desc, setDesc] = useState<string>('');
  const [preOutLocationTypes, setPreOutLocationTypes] = useState<number[]>(
    DEFAULT_CREATE_REQUIREMENT_PRE_OUT_LOCATION_TYPES,
  );

  useEffect(() => {
    if (open) {
      setFailAdd(null);
      setFailItems([]);
      setPreOutLocationTypes(DEFAULT_CREATE_REQUIREMENT_PRE_OUT_LOCATION_TYPES);
    }
  }, [open]);

  const scrollHeight = useMemo(() => {
    return (conetentRef?.current?.getBoundingClientRect()?.height || 600)
  }, [conetentRef?.current])

  const hasPreOutItems = () => matchedProducts.some(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0);

  const renderPreOutLocationTypeSelect = () => (
    <Form.Item
      required
      label={t('requirement.matchLocType')}
      style={{ marginBottom: 0, flex: 1, minWidth: 0 }}
    >
      <SelectLocationType
        mode="multiple"
        style={{ flex: 1 }}
        value={locTypes.length > 0 ? locTypes : preOutLocationTypes}
        onChange={locTypes.length > 0 ? undefined : setPreOutLocationTypes}
        allowClear maxTagCount={2}
      />
    </Form.Item>
  );

  const confirmTableTabs = <Tabs
    type="card" items={[
      {
        label: <SText text={t('layout.requirementList')} />,
        key: 'requirementList',
        children: <PreOutData setMatchedProducts={setMatchedProducts}
          toolbarExtra={hasPreOutItems() && renderPreOutLocationTypeSelect()}
          confirmProducts={matchedProducts.filter(item => item.useAmount > 0)}
          scrollHeight={scrollHeight} confirmed
        />
      },
      {
        label: <SText text={t('requirement.preOutInventory')} />,
        key: 'preOutInventory',
        children: <PreOutData
          toolbarExtra={hasPreOutItems() && renderPreOutLocationTypeSelect()}
          confirmProducts={matchedProducts.filter(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0)}
          scrollHeight={scrollHeight}
        />
      },

    ]}
  />

  const steps = [
    {
      title: t('requirement.selectProdPro'),
      content: (
        <Form<IRequirementKeys>
          form={form}
          name="requirement"
          autoComplete="off"
          initialValues={{ requireCount: 1 }} size="large"
        >
          <Form.Item
            label={t("requirement.product")}
            name="productId"
          // rules={[{ required: false, message: t("requirement.plSelectProdPro") }]}
          >
            <ProductSelect allowClear defaultList={proTemp ? [proTemp] : []}
              placeholder={t('requirement.plSelectProdPro')}
              getSelectPro={data => setProTemp(data)}
              onClear={() => {
                setProTemp(null)
                form.setFieldValue("requireCount", 1)
                form.setFieldValue("productId", undefined)
              }
              }
            />
          </Form.Item>
          <Form.Item required label={t("requirement.prodCount")} name="requireCount" rules={[{ required: true, message: t("requirement.plProdCount") }]}>
            <InputNumber changeOnWheel formatter={val => numFormmater(Number(val || 0))}
              value={proTemp ? form.getFieldValue("requireCount") : 1} disabled={!proTemp} min={1} precision={0} style={{ width: '100%' }} placeholder={t("requirement.plProdCount")} />
          </Form.Item>
          <Form.Item required label={t("requirement.mrd")} name="mrd" rules={[{ required: true, message: t("requirement.mrd") }]}>
            <DatePicker style={{ width: '100%' }} placeholder={t("requirement.mrd")} />
          </Form.Item>
          <Form.Item required label={t("requirement.eps")} name="eps" rules={[{ required: true, message: t("requirement.eps") }]}>
            <DatePicker style={{ width: '100%' }} placeholder={t("requirement.plProdCount")} />
          </Form.Item>
        </Form>
      )
    },
    {
      title: t("requirement.matchBom"),
      content: bomLoading ? <Flex style={{ width: "100%" }} justify="center">
        <Spin style={{ marginTop: 140 }} />
      </Flex> : <MatchBom bomSubs={subs} setBomSubs={setSubs} scrollHeight={scrollHeight} />,
    },
    {
      title: t("requirement.plSubPro"),
      content: <EditRequirement purchaseProducts={subs} setPurchaseProducts={setSubs} isMerge={isMerge} setIsMerge={setIsMerge}
        isHandleAdd={true} requireCount={form.getFieldValue('requireCount')}
        matchStock={matchStock} setMatchStock={setMatchStock} matchFactory={matchFactory} setMatchFactory={setMatchFactory} scrollHeight={scrollHeight}
        locTypes={locTypes} setLocTypes={setLocTypes}
      />,
    },
    {
      title: t("requirement.matchInventory"),
      key: "3",
      content: (
        <MatchStock
          isMerge={isMerge}
          purchaseProducts={subs}
          matchedProducts={matchedProducts}
          setMatchedProducts={setMatchedProducts}
          requireCount={Number(form.getFieldValue("requireCount") || 1)}
          scrollHeight={scrollHeight}
          setDisNext={setDisNext}
          matchFactory={matchFactory}
          locTypes={locTypes}
        />
      )
    },
    {
      title: t("bom.confirmAdd"),
      key: "6",
      content: (<DataWrap>
        <RequirementForm onValuesChange={(d, data) => setFormData(data)} greyItems={pageId === PageId.MC_NOT_PASS ? [RequirementConfirmTypeEnum.SALE] : []} />
        {
          matchedProducts.filter(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0).length > 0 && <Form.Item label={t('requirement.preOutDesc')} style={{ marginBottom: 2 }}>
            <Input.TextArea size="small" autoSize={{ minRows: 1, maxRows: 1 }} maxLength={200} value={desc} onChange={e => setDesc(e.target.value)} />
          </Form.Item>
        }
        <div className="data-container">
          {confirmTableTabs}
        </div>
      </DataWrap>),
    },
    // {
    //   title: t("requirement.addDesc"),
    //   content: <RequirementForm handleAdd disableItems={[RequirementConfirmTypeEnum.MATERIAL_CONTROL]} onValuesChange={(d, data) => setFormData(data)} greyItems={pageId === PageId.MC_NOT_PASS ? [RequirementConfirmTypeEnum.SALE] : []} />,
    // },
    {
      title: t("requirement.done"),
      content: (
        (!!failItems.length && !!failAdd) ? (
          <ReTryPreOut failAdd={failAdd} failItems={failItems}
            number={number} scrollHeight={scrollHeight}
            onOk={() => { setFailItems([]); setFailAdd(null) }}
            locTypes={locTypes} preOutLocationTypes={preOutLocationTypes}
          />
        )
          : (<Result
            status="success"
            title={t("requirement.doneSuccess")}
            subTitle={t("requirement.doneSuccessTip", { number })}
          />)
      ),
    },
  ];

  const next = () => {
    if (current === 0) {
      form.validateFields()
        .then(() => {
          let productId = form.getFieldValue("productId")
          if (productId) {
            fetchTemp(form.getFieldValue("productId"))
            setCurrent(current + 1);
          } else setCurrent(current + 2);
        }).catch((err) => {
          const errTitle = t("requirement.validError");
          const errorDesc = err?.errorFields[0]?.errors[0] ?? "";
          notification.error({
            placement: 'top',
            message: errTitle,
            description: errorDesc,
          });
        })
    } else if (current === 2) {
      for (let i = 0; i < subs.length; i++) {
        const data = subs[i];
        if (!!data.beReplaced) {
          let repCount = 0;
          subs.filter(sub => sub.replaceParentId === data.product.id)
            .forEach(sub => {
              repCount += Number(sub.useAmount || '')
            })
          if (Number(data.bomRequireCount || '') !== Number(data.useAmount || '') - Number(data.extCount || '') + repCount) {
            notification.error({
              message: t('bom.calcErr'),
              description: (
                <>
                  <div>{t('bom.calcData')}</div>
                  <div style={{ color: "red" }}>{data.product.code}</div>
                </>
              ),
              duration: 10
            });
            return;
          }
        }
      }
      if (subs.find(sub => sub.useAmount > 0)) {
        if (!matchStock) setCurrent(current + 1);
        else {
          const matched: MatchedRequirementColumn[] = subs.map(s => ({
            ...s,
            stockNum: 0,
            stockPreOut: 0,
            useNum: 0,
            allocated: 0,
            purCount: s.product.preReady === 1 ? 0 : s.useAmount,
            preOutNum: 0,
            preIn: 0,
            matchKey: '',
            useFactoryCount: 0,
            factoryCount: 0,
            factoryAllocated: 0,
          }));
          setMatchedProducts([...matched]);
          setCurrent(4);
        }
      }
      else notification.error({ placement: 'top', message: t('bom.errTip'), description: t('bom.errTipdesc') })
    } else if (current === 3) {
      let errRows = matchedProducts.filter(mp => mp.allocated > mp.useNum).map(r => r.product.code)
      if (errRows.length > 0) return notification.error({
        message: t('requirement.overTip'),
        description: Array.from(new Set(errRows)).join(', ')
      })
      setCurrent(current + 1);
    } else if (current === 4) {
      if (hasPreOutItems() && !hasCreateRequirementPreOutLocationTypes(preOutLocationTypes)) {
        return notification.warning({
          placement: 'top',
          message: '请选择出库匹配库位类型',
        });
      }
      setOpenConfirm(true);
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    if (current !== 2 && current !== 4) setCurrent(current - 1);
    if (current === 2 && form.getFieldValue("productId")) setCurrent(current - 1);
    if (current === 2 && !form.getFieldValue("productId")) setCurrent(current - 2);
    if (current === 4 && matchStock) setCurrent(2);
    if (current === 4 && !matchStock) setCurrent(current - 1);
  };

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const addRequirement = (val: string) => {
    const addInfo: Partial<RequirementAdd> = {
      sourceType: null,
      sourceId: null,
      productId: form.getFieldValue('productId'),
      bomHisId: "",
      desc: formData?.tip || "",
      requireCount: form.getFieldValue('requireCount'),
      mrd: dayjs(form.getFieldValue('mrd')).endOf('day').valueOf(),
      eps: dayjs(form.getFieldValue('eps')).endOf('day').valueOf(),
      items: matchedProducts.filter(item => !!item?.useAmount && item.useAmount > 0).map((item) => {
        let baseQuantityNumber = roundToDecimal(Number(item?.baseQuantity) || 0);
        return {
          productId: item.product.id,
          bomItemId: item.bomItemId, // bomId
          bomReplId: item.bomReplId, // 替代料的bomId
          useRepl: RequirementAddItemUseRepl.NOT_USE,
          maxEstimatedPriceId: "",
          minEstimatedPriceId: "",
          maxEstimatedCost: "",
          minEstimatedCost: "",
          useAmount: !!item?.useAmount ? item.useAmount + '' : '', // 使用数量
          desc: "",
          purCount: item.purCount.toString(),
          puredCount: "0",
          outCount: "0",
          ert: null,
          extCount: item.extCount.toString(),
          supplierId: "",
          attritionRate: (item?.attritionRate ?? 0).toString(),
          baseCount: baseQuantityNumber === 0 ? '' : baseQuantityNumber + '',
          matchKey: item.matchKey,
          bomAmount: baseQuantityNumber === 0 ? '' : baseQuantityNumber + '',
          useFactoryCount: item.useFactoryCount,
          process: item.bomProcess
        }
      }),
      confirms: getRequirementConfirmItem((formData?.steps || []).map((item) => ({ ...item, value: null, desc: '' })), RequirementConfirmTypeEnum.MATERIAL_CONTROL, "next", val)
    };
    add(addInfo, (res) => {
      const requirementItems = [...res.items];
      const factoryOut: Record<string, number> = {};
      requirementItems.forEach(r => {
        if (!!factoryOut[r.productId]) factoryOut[r.productId] -= (Number(r.useFactoryCount) || 0)
        else factoryOut[r.productId] = 0 - (Number(r.useFactoryCount) || 0)
      });
      const facInfo: AddFactoryInventory = {
        sourceType: FactoryInventorySourceType.REQUIREMENT,
        sourceId: res.id,
        items: Object.entries(factoryOut).map(([productId, count]) => ({ productId, count })).filter(i => i.count !== 0),
        desc: ''
      }
      if (facInfo.items.length > 0) {
        fInventoryAdjust(facInfo)
          .catch((error: any) => {
            let description = '';
            if (error?.code === 70873) {
              let product = matchedProducts.find(p => p.product.id === error?.extra?.productId)?.product!
              description = t('apiError.error31') + ': ' + product.code
            }
            notification.error({ message: t('warehouse.outFail'), description })
          })
      };
      let matchItems = matchedProducts.filter(i => i.preOutNum && i.preOutNum > 0 && i.product.preReady === 0);
      let order: OrderAddV2 = {
        arrivalAt: null,
        preTime: null,
        type: ChangeEnum.PRE_OUT,
        opType: OperateEnum.PICKING,
        desc,
        items: matchItems.map(item => ({
          sourceType: SourceTypeEnum.REQUIREMENT_ITEM,
          sourceId: requirementItems.find(rtm => rtm.matchKey === item.matchKey)?.id ?? '',
          productId: item.product.id,
          count: item.preOutNum,
          desc: '',
          lot: '',
          thdlot: '',
          locations: [],
        })),
      }
      if (order.items.length > 0) {
        let resOrder: OrderV2 | null = null;
        (async () => {
          resOrder = await orderAdd(order);
          await orderPreOut(resOrder?.id ?? '', locTypes.length > 0 ? locTypes : preOutLocationTypes)
          notification.success({ placement: 'top', message: t('requirement.createPreOutInventorySuccess'), description: t('bom.inventorySucc', { number: res.number }) })
        })().catch((err: any) => {
          if (!!!resOrder) {
            setFailAdd(order);
            setFailItems(matchItems);
          }
          if (err?.code === 73010) {
            notification.error({
              message: t('inventory.proQtyFalse'),
              description: err?.extra?.map((i: { productId: string }) => i.productId)?.join(', ')
            })
          } else if ([73022, 73014].includes(err)) {
            notification.error({
              message: t('inventory.calcErr')
            })
          } else if ([73024, 73028].includes(err.code)) {
            notification.error({
              message: t('warehouse.insufficientInventory'),
              description: err?.extra?.productCode
            })
          }
          notification.info({ placement: 'top', message: t('requirement.createPreOutInventoryFail'), description: t('requirement.doneSuccess') })
        })
      }
      setNumber(res.number)
      setCurrent(current + 1);
      setSubs([])
    })
  };

  const fetchTemp = (productId: string) => {
    setBomLoading(true)
    requirementApis.tempFetch(productId)
      .then((res) => {
        if (res.length > 0) {
          setSubs(
            res.map((bsI) => ({
              product: bsI.product,
              useAmount: Math.ceil(
                Number(
                  plus(
                    multi(bsI.useAmount.toString(), form.getFieldValue("requireCount")),
                    bsI.extCount
                  )
                )
              ),
              reqs: [],
              useRepl: RequirementAddItemUseRepl.NOT_USE,
              bomItemId: "",
              bomReplId: "",
              bomRequireCount: Math.ceil(Number(
                multi(bsI.useAmount.toString(), form.getFieldValue("requireCount"))
              )),
              extCount: Number(bsI.extCount),
              baseQuantity: Number(bsI.baseCount),
              attritionRate: Number(bsI.attritionRate),
              useQuantity: Math.ceil(Number(bsI.useAmount)),
            }))
          );
        }
        else {
          const getFinanceRequireData = (bomItem: BomItem): RequirementColumn[] => {
            let reqs: Array<RequirementColumn> = [];
            // 如果不是 'formal' 类型，直接返回空数组
            if (bomItem.type !== "formal") {
              return [];
            }
            // 如果有子项，递归调用并合并结果
            if (
              bomItem.subs.filter((item) => item.type === "formal").length > 0
            ) {
              return bomItem.subs.flatMap((subItem) =>
                getFinanceRequireData(subItem)
              );
            }

            const getRealQuantity = (item: BomItem) => {
              const rate = divided(item.attritionRate.toString(), "100");
              const itemRate = multi(item.useQuantity, rate);
              const itemQuantity = plus(item.useQuantity, itemRate);
              const allQuantity = multi(
                itemQuantity,
                form.getFieldValue("requireCount")
              );

              return Math.ceil(Number(allQuantity));
            };

            reqs = bomItem.subs
              .filter((item) => item.type === "req")
              .map((bI) => ({
                product: bI.product,
                useAmount: getRealQuantity(bI),
                reqs: [],
                useRepl: RequirementAddItemUseRepl.USED,
                bomItemId: bomItem.id,
                bomReplId: bI.id,
                bomRequireCount: getRealQuantity(bI),
                extCount: 0,
                attritionRate: Number(bI.attritionRate),
                baseQuantity: Number(bI.baseUnit),
                useQuantity: Number(bI.useQuantity),
              }));

            // 如果没有子项，返回当前项的转换结果
            return [
              {
                product: bomItem.product,
                useAmount: getRealQuantity(bomItem),
                reqs,
                useRepl: RequirementAddItemUseRepl.NOT_USE,
                bomItemId: bomItem.id,
                bomReplId: "",
                attritionRate: Number(bomItem.attritionRate),
                baseQuantity: Number(bomItem.baseUnit),
                bomRequireCount: getRealQuantity(bomItem),
                extCount: 0,
                useQuantity: Number(bomItem.useQuantity),
                bomProcess: bomItem.process ?? undefined
              },
            ];
          };
          fetch(productId)
            .then(res => {
              const items: RequirementColumn[] = res.items.flatMap((bI) => {
                let i = getFinanceRequireData(bI)
                return i
              }
              );
              setSubs(items);
            })
            .catch(err => { })
        }
      })
      .finally(() => setBomLoading(false))
  };

  const handleCancel = () => {
    setOpen(false)
    setCurrent(0)
    form.resetFields()
    setSubs([]);
  };

  return (
    <>
      <ModalWrap onCancel={() => {
        if (current === steps.length - 1) {
          if (!!failAdd && !!failItems.length) {
            modal.confirm({
              title: t('requirement.failPreTip'),
              content: t('requirement.failPreTipDesc'),
              onOk: () => handleCancel()
            })
          } else handleCancel();

        } else modal.confirm({
          title: t('common.tip'),
          content: t('bom.closeTip'),
          onOk: () => handleCancel()
        })
      }} open={open} title={t('requirement.addRequirement')} centered footer={null} width='100vw' height='100vh' >
        <Steps current={current} items={items} />
        <div className="step-content" ref={conetentRef} style={{ marginTop: 10 }}>{steps[current].content}</div>
        <div style={{ marginTop: 24 }}>
          {current < steps.length - 1 && (
            <Button type="primary" loading={addLoading || disNext} onClick={() => next()}>
              {t('requirement.next')}
            </Button>
          )}
          {current !== 0 && current !== steps.length - 1 && (
            <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
              {t('requirement.previous')}
            </Button>
          )}
        </div>

      </ModalWrap>
      <RequirementSteps
        id={""}
        visible={openConfirm}
        confirms={[]}
        onClose={() => setOpenConfirm(false)}
        onOk={(val) => {
          if (hasPreOutItems() && !hasCreateRequirementPreOutLocationTypes(preOutLocationTypes)) {
            notification.warning({
              placement: 'top',
              message: '请选择出库匹配库位类型',
            });
            setOpenConfirm(false);
            return;
          }
          addRequirement(val ?? "");
          setOpenConfirm(false);
        }}
      />
    </>
  )
}

export default RequirementHandleAdd;
